/* ============================================================
   LEFTOVRZ — recently viewed, and Call it

   Both are re-runnable and expose window.__lvEngage, because the product
   page arrives through a Barba container swap as often as through a real
   page load and neither can rely on running once at parse time.
   ============================================================ */
(() => {
  'use strict';

  const KEY = 'lv:seen';
  const money = (cents) =>
    (typeof window.__lvMoney === 'function'
      ? window.__lvMoney(cents)
      : String(Math.round((cents || 0) / 100)));

  const esc = (t) => String(t == null ? '' : t)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  /* localStorage throws outright in a private window on some browsers, and
     comes back empty on others. Neither is worth breaking a page over. */
  const load = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  };
  const save = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  };

  /* ---------- 1. recently viewed ---------------------------------------- */
  const recent = () => {
    const sec = document.querySelector('[data-recent]');
    const seenTag = document.querySelector('[data-lv-seen]');

    /* Record first, render second, so the pair you are looking at is in the
       history for the NEXT page rather than listed on its own page. */
    let current = null;
    if (seenTag) {
      try { current = JSON.parse(seenTag.textContent); } catch (e) { current = null; }
    }
    if (current && current.handle) {
      const keep = Math.max(4, +((sec && sec.dataset.keep) || 12));
      const list = load().filter((x) => x && x.handle !== current.handle);
      list.unshift(current);
      save(list.slice(0, keep));
    }

    if (!sec) return;
    const ul = sec.querySelector('[data-recent-list]');
    if (!ul) return;

    const here = current && current.handle;
    const items = load().filter((x) => x && x.handle && x.handle !== here);

    if (!items.length) { sec.hidden = true; return; }

    ul.innerHTML = items.map((p) => `<li class="card" data-handle="${esc(p.handle)}">
  <a class="card__link" href="${esc(p.url)}" aria-label="${esc(p.title)}"></a>
  <div class="card__media"${p.img ? ' data-filled' : ''}>
    ${p.img ? `<img src="${esc(p.img)}" srcset="${esc(p.img)} 700w" sizes="180px" alt="" loading="lazy" width="700" height="700">` : ''}
    <span class="tag ${p.available ? 'tag--in' : 'tag--out'}">${p.available ? 'In stock' : 'Sold out'}</span>
    ${p.cond ? `<span class="card__cond">${esc(p.cond)}</span>` : ''}
    <button class="card__peek" type="button" data-quick-view="${esc(p.handle)}"
            aria-label="Quick view: ${esc(p.title)}">
      <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
           stroke-width="1.7" aria-hidden="true"><path d="M1.8 12S5.6 5 12 5s10.2 7 10.2 7-3.8 7-10.2 7S1.8 12 1.8 12Z"/><circle cx="12" cy="12" r="3.1"/></svg>
    </button>
  </div>
  <div class="card__body">
    <h3 class="card__name">${esc(p.title)}</h3>
    <p class="card__meta">
      <span class="card__prices">
        <span class="price">${esc(p.priceStr)}</span>
        ${p.onSale ? `<s class="price--was">${esc(p.wasStr)}</s><span class="price__off">&minus;${esc(p.off)}%</span>` : ''}
      </span>
    </p>
  </div>
</li>`).join('');
    sec.hidden = false;

    const clear = sec.querySelector('[data-recent-clear]');
    if (clear && !clear.dataset.wired) {
      clear.dataset.wired = '1';
      clear.addEventListener('click', () => {
        try { localStorage.removeItem(KEY); } catch (e) {}
        ul.innerHTML = '';
        sec.hidden = true;
      });
    }
  };

  /* ---------- 2. Call it ------------------------------------------------ */
  const REDUCE = matchMedia('(prefers-reduced-motion: reduce)');

  /* Counts one number to another on a timer rather than rAF. A tab that is
     not in front pauses frames but keeps firing timers, so this always
     arrives at the answer instead of freezing part-way to it. */
  const rollTo = (el, from, to, ms, paint) => {
    if (REDUCE.matches || ms <= 0) { paint(el, to); return Promise.resolve(); }
    return new Promise((done) => {
      const t0 = Date.now();
      const tick = setInterval(() => {
        const k = Math.min(1, (Date.now() - t0) / ms);
        /* ease-out-cubic: quick off the mark, settles onto the number */
        const e = 1 - Math.pow(1 - k, 3);
        paint(el, Math.round(from + (to - from) * e));
        if (k >= 1) { clearInterval(tick); done(); }
      }, 16);
    });
  };

  const callit = () => {
    const root = document.querySelector('[data-callit]');
    if (!root || root.dataset.wired) return;
    root.dataset.wired = '1';

    const range   = root.querySelector('[data-callit-range]');
    const out     = root.querySelector('[data-callit-out]');
    const cap     = root.querySelector('[data-callit-cap]');
    const badge   = root.querySelector('[data-callit-badge]');
    const go      = root.querySelector('[data-callit-go]');
    const stage   = root.querySelector('[data-callit-stage]');
    const result  = root.querySelector('[data-callit-result]');
    const verdict = root.querySelector('[data-callit-verdict]');
    const again   = root.querySelector('[data-callit-again]');
    const truthPin = root.querySelector('[data-callit-truth]');
    const oursPin  = root.querySelector('[data-callit-ourpin]');
    if (!range || !out || !go || !result || !stage) return;

    const retail = +root.dataset.retail;
    const ours   = +root.dataset.ours;
    const show = (el, units) => { el.textContent = money(units * 100); };
    const paint = () => show(out, +range.value);
    range.addEventListener('input', paint);
    paint();

    /* decoration only, and only with someone there to see it */
    const flash = (el, cls) => {
      if (!el || document.hidden || REDUCE.matches) return;
      el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
    };
    const hold = (ms) => new Promise((r) => setTimeout(r, REDUCE.matches ? 0 : ms));

    go.addEventListener('click', async () => {
      if (stage.classList.contains('is-spent')) return;
      const guess = +range.value;
      const miss = Math.abs(guess - retail) / retail;
      stage.classList.add('is-spent');

      /* ---- first: what it went for ---- */
      cap.textContent = 'What it went for';
      out.classList.add('is-rolling');
      await rollTo(out, guess, retail, 900, show);
      out.classList.remove('is-rolling');
      root.classList.add('is-called');
      flash(truthPin, 'is-anim');

      verdict.textContent =
        miss <= 0.08 ? 'Sharp eye. That is almost exactly it.'
        : miss <= 0.2 ? 'Close. You know what these go for.'
        : guess > retail ? 'Under it. These went for less than you thought.'
        : 'Over it. These went for more than you thought.';

      /* ---- then the point of the whole thing: what we are asking ----
         The same figure FALLS to our price rather than a second number
         appearing beside it, so the drop itself is the animation. It is
         struck through on the way down so the fall reads as coming off
         the retail figure. */
      await hold(760);
      out.classList.add('is-retail');
      await hold(320);
      cap.textContent = 'What we are asking';
      out.classList.add('is-rolling');
      await rollTo(out, retail, ours, 820, show);
      out.classList.remove('is-rolling', 'is-retail');
      out.classList.add('is-ours');
      stage.classList.add('is-ours');
      root.classList.add('is-ours');
      flash(oursPin, 'is-anim');

      if (badge) { badge.hidden = false; flash(badge, 'is-anim'); }

      result.hidden = false;
      flash(result, 'is-anim');
      flash(verdict, 'is-anim');
    });

    if (again) again.addEventListener('click', () => {
      result.hidden = true;
      if (badge) badge.hidden = true;
      stage.classList.remove('is-spent', 'is-ours');
      root.classList.remove('is-called', 'is-ours');
      out.classList.remove('is-ours', 'is-retail', 'is-rolling');
      cap.textContent = 'Your call';
      for (const el of root.querySelectorAll('.is-anim')) el.classList.remove('is-anim');
      paint();
      range.focus();
    });
  };


  /* ---------- 3. rail arrows -------------------------------------------
     Delegated on the document, so it needs no re-initialising after a page
     swap and covers rails that do not exist yet. Scoped to [data-railnav] on
     purpose: the home page's own rails are already driven by
     leftovrz-home.js and the Keep browsing rail by its own inline script, so
     a second handler on those would scroll them twice per click.

     Scrolling is left to the browser — this only nudges scrollLeft, which is
     the same thing a swipe or a two-finger trackpad gesture does, so all
     three end up in exactly the same state. */
  const rails = () => {
    for (const nav of document.querySelectorAll('[data-railnav]')) {
      if (nav.dataset.wired) continue;
      const wrap = nav.closest('[data-railwrap]');
      const sec = wrap ? wrap.closest('section, .sec') : null;
      const track = sec ? sec.querySelector('.rail') : null;
      if (!track) continue;
      nav.dataset.wired = '1';

      const ends = () => {
        const max = track.scrollWidth - track.clientWidth;
        const x = track.scrollLeft;
        for (const b of nav.querySelectorAll('[data-rail-dir]')) {
          const back = +b.dataset.railDir < 0;
          b.disabled = max <= 1 || (back ? x <= 1 : x >= max - 1);
        }
      };

      nav.addEventListener('click', (e) => {
        const b = e.target.closest('[data-rail-dir]');
        if (!b) return;
        /* one card plus its gutter, so a press lands on a card edge rather
           than halfway through one */
        const card = track.querySelector('li, .card, .pcard');
        const step = card ? card.getBoundingClientRect().width + 2 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * +b.dataset.railDir,
                         behavior: REDUCE.matches ? 'auto' : 'smooth' });
        /* Re-check after the press as well as on scroll. A smooth scroll that
           is interrupted — or never starts, which is what a backgrounded tab
           does to it — fires no scroll event, and the arrows would then keep
           claiming there is more in a direction that has run out. */
        setTimeout(ends, 420);
        setTimeout(ends, 900);
      });

      /* the arrows follow the rail however it was moved */
      track.addEventListener('scroll', () => {
        clearTimeout(nav._t);
        nav._t = setTimeout(ends, 60);
      }, { passive: true });
      addEventListener('resize', () => { clearTimeout(nav._t); nav._t = setTimeout(ends, 120); });
      ends();
    }
  };

  const run = () => { recent(); callit(); rails(); };
  window.__lvEngage = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
